module.exports = "<ngx-qrcode [qrc-element-type]=\"elementType\" [qrc-value] = \"value\">\r\n</ngx-qrcode>"